import { createIconComponent } from './helpers';
import { faAngleRight } from '@fortawesome/free-solid-svg-icons'

export const RightArrowIcon = createIconComponent(faAngleRight);
